var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"problem-report"},[_c('TitleBreadcrumb'),_c('div',{staticClass:"content-base container"},[_c('a-row',{attrs:{"type":"flex","justify":"center","gutter":[16, 16]}},[_c('a-col',{attrs:{"md":16}},[_c('ProblemReportForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }